import {PeachyRepoRoot} from '@peachy/repo-domain'
import {AbstractArrayRepository, RepoEntityWithId} from '@peachy/flash-repo-pure'
import {PeachyRepoRootNode} from '../../types'

export abstract class PeachyArrayRepository<RepoEntity extends RepoEntityWithId> extends AbstractArrayRepository<RepoEntity, PeachyRepoRoot, PeachyRepoRootNode> { }
